import { render, staticRenderFns } from "./PosCounterHeader.vue?vue&type=template&id=9ed09f84&scoped=true"
import script from "./PosCounterHeader.vue?vue&type=script&lang=js"
export * from "./PosCounterHeader.vue?vue&type=script&lang=js"
import style0 from "./PosCounterHeader.vue?vue&type=style&index=0&id=9ed09f84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ed09f84",
  null
  
)

export default component.exports